module.exports = __webpack_public_path__ + "static/media/icon-tv-WHITE.abaa07f0.svg";